import { RiLeafLine } from "@remixicon/react";

export function LoadingState() {
  return (
    <div className="flex h-full flex-col items-center justify-center p-6">
      <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-primary-100">
        <RiLeafLine className="h-6 w-6 animate-pulse text-primary-600" />
      </div>
      <p className="text-paragraph-sm text-text-sub-600">Loading Earth Note...</p>
    </div>
  );
}
